import * as React from 'react';
import './index.css';
export default function PaymentPlateHead(props) {
    var detailsData = props.detailsData;
    return (React.createElement("div", { className: 'payment_plate_details_box' },
        React.createElement("div", { className: 'payment_plate_item_box', style: { backgroundColor: '#F6F7F9' } },
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '212px'
                } }, "\u91D1\u989D\u4EBA\u6C11\u5E01\uFF08\u5927\u5199\uFF09"),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '556px'
                } }, detailsData.totalAmountText),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '226px'
                } }, "\u5408\u8BA1(\u00A5)"),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'right',
                    flex: 1
                } }, detailsData.totalAmount)),
        React.createElement("div", { className: 'payment_plate_item_box' },
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '212px'
                } }, "\u7533\u8BF7\u5355\u4F4D\u7F16\u53F7"),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '186px'
                } }, detailsData.applyNumber),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '139px'
                } }, "\u62A5\u5173\u5355\u7F16\u53F7"),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'left',
                    width: '231px'
                } }, detailsData.customsNumber),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'center',
                    width: '226px'
                } }, "\u586B\u5236\u5355\u4F4D"),
            React.createElement("div", { className: 'payment_plate_item', style: {
                    textAlign: 'center',
                    flex: 1
                } }, "\u6536\u6B3E\u56FD\u5E93(\u94F6\u884C)")),
        React.createElement("div", { className: 'payment_number_box' },
            React.createElement("div", { className: 'payment_plate_content_box' },
                React.createElement("div", { className: 'payment_plate_item_box' },
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '212px'
                        } }, "\u5408\u540C(\u6279\u6587)\u53F7"),
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '186px'
                        } }, detailsData.contractNumber),
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '139px'
                        } }, "\u8FD0\u8F93\u5DE5\u5177(\u53F7)"),
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '231px'
                        } }, detailsData.transportNumber)),
                React.createElement("div", { className: 'payment_plate_item_box' },
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '212px'
                        } }, "\u7F34  \u6B3E  \u671F  \u9650"),
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '186px'
                        } }, detailsData.paymentPeriod),
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '139px'
                        } }, "\u63D0/\u88C5\u8D27\u5355\u53F7"),
                    React.createElement("div", { className: 'payment_plate_item', style: {
                            textAlign: 'left',
                            width: '231px'
                        } }, detailsData.goodsNumber)),
                React.createElement("div", { className: 'payment_plate_remark_box' },
                    React.createElement("div", { className: 'payment_plate_remark_title' }, "\u5907\u6CE8"),
                    React.createElement("div", { className: 'payment_plate_remark_text' }, detailsData.remark))),
            React.createElement("div", { className: 'payment_plate_fill_company' }, detailsData.fillCompany),
            React.createElement("div", { className: 'payment_plate_fill_bank' }, detailsData.collectionBank))));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/PaymentPlate/PaymentPlateDetails/index.js
// module id = 4225
// module chunks = 0